import "react-notifications/lib/notifications.css";
import showToastNotification from "./showToast";
import { io } from "socket.io-client";
import { WEBSOCKET_URL } from "../services/environment";
import {Colors} from "../assets/colors";
var socket;
var questionNoArray = []
var shuffledArray = []
class Utils {
  static shuffle(arra1) {
    var ctr = arra1.length, temp, index;

    while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
    }
    return arra1;
  }
  static setRandomiserArray =async() =>{
    shuffledArray = []
    questionNoArray = []
    for(var i=0;i<87;i++){
      questionNoArray.push(i)
    }
    shuffledArray =await this.shuffle(questionNoArray)
    return  shuffledArray 
    
  }
  static getRandomiserArray =async(toRemove) =>{
    if(shuffledArray.length === 0){
    const set = new Set(toRemove);
      const difference = await shuffledArray.filter( x => !set.has(x) );
      shuffledArray = difference
      return shuffledArray 
    }else{
      const set = new Set(toRemove);
      const difference = await shuffledArray.filter( x => !set.has(x) );
      shuffledArray = difference
      return shuffledArray 
    }
  }

  static  getTextColor = (text) => {
    
    if(text !== "")
    {
      if(text.includes("Money/Debt")){
        return Colors.RED
      }
      else if(text.includes("Time/Energy")){
        return Colors.YELLOW
      }
      else if(text.includes("Home/Family")){
        return Colors.GREEN_COLOR
      }
      else if(text.includes("Work/Job")){
        return Colors.DARK_GREEN
      }
    }else{
      return Colors.RED
    } 
  };

  static  printTextwithColor = (text) => {
    if(text !== "" && text.includes("+"))
    {
      var pieces = text.split("+");
      var output = "";
      var output2 = ""; 
      var output1 = "";
      var output3 = "";
      for (const [i, textData] of pieces.entries()) {
        if(textData.includes("Money/Debt")){
          if(i === "1"){
            output1 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Money_Debt" style={{color: Colors.RED}}>{textData}</span></>;
          } else if(i === "2"){
            output2 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Money_Debt" style={{color: Colors.RED}}>{textData}</span></>;
          } else if(i === "3"){
            output3 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Money_Debt" style={{color: Colors.RED}}>{textData}</span></>;
          } else {
            output = <span className="Money_Debt" style={{color: Colors.RED}}>{textData}</span>;
          }
        }
        
        if(textData.includes("Time/Energy")){
          if(i === "1"){
            output1 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Time_Energy" style={{color: Colors.YELLOW}}>{textData}</span></>;
          } else if(i === "2"){
            output2 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Time_Energy" style={{color: Colors.YELLOW}}>{textData}</span></>;
          } else if(i === "3"){
            output3 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Time_Energy" style={{color: Colors.YELLOW}}>{textData}</span></>;
          } else {
            output = <span className="Time_Energy" style={{color: Colors.YELLOW}}>{textData}</span>;
          }
        }

        if(textData.includes("Home/Family")){
          if(i === "1"){
            output1 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Home_Family" style={{color: Colors.GREEN_COLOR}}>{textData}</span></>;
          } else if(i === "2"){
            output2 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Home_Family" style={{color: Colors.GREEN_COLOR}}>{textData}</span></>;
          } else if(i === "3"){
            output3 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Home_Family" style={{color: Colors.GREEN_COLOR}}>{textData}</span></>;
          } else {
            output = <span className="Home_Family" style={{color: Colors.GREEN_COLOR}}>{textData}</span>;
          }
        }

        if(textData.includes("Work/Job")){
          if(i === "1"){
            output1 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Work_Job" style={{color: Colors.DARK_GREEN}}>{textData}</span></>;
          } else if(i === "2"){
            output2 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Work_Job" style={{color: Colors.DARK_GREEN}}>{textData}</span></>;
          } else if(i === "3"){
            output3 = <><span class="plus" style={{color: Colors.BLACK}}> + </span><span className="Work_Job" style={{color: Colors.DARK_GREEN}}>{textData}</span></>;
          } else {
            output = <span className="Work_Job" style={{color: Colors.DARK_GREEN}}>{textData}</span>
          }
        }
      }

      return (
        <>
        {output}
        {output1}
        {output2}
        {output3}
        </>
      );
    }else{
      if(text.includes("Money/Debt")){
        return ( <span style={{color: Colors.RED}}>{text}</span> );
      }
      else if(text.includes("Time/Energy")){
        return ( <span style={{color: Colors.YELLOW}}>{text}</span> );
      }
      else if(text.includes("Home/Family")){
        return ( <span style={{color: Colors.GREEN_COLOR}}>{text}</span>);
      }
      else if(text.includes("Work/Job")){
        return ( <span style={{color: Colors.DARK_GREEN}}>{text}</span>);
      } else {
        return ( <span style={{color: Colors.RED}}>{text}</span> );
      }
    }
  };

  static  getConnectedSocket = async() => {
    console.log("socket error= ", io(`${WEBSOCKET_URL}`, {
       path: "/socket.io",
       transports: ["websocket", "polling"],
       secure: true,
     }));
    console.log("WEBSOCKET_URL = ", WEBSOCKET_URL);
    if(typeof socket === "undefined"){

     socket = io(`${WEBSOCKET_URL}`, {
       path: "/socket.io",
       transports: ["websocket", "polling"],
       secure: true,
       autoConnect: true,
     });
    console.log("socket connect = ", socket.connect());
    //socket.connect();
socket.on('connect', () => {
  console.log('Socket connected successfully:', socket.id);
});

socket.on('connect_error', (error) => {
  console.error('Socket connection failed:', error);
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', reason);
});
     console.log("Socket_Object_NEW_Connected")

     return socket
    }
    return socket
  };
  static disconnectSocket = () => {
    if(socket !== null){
      socket.disconnect();
      socket = undefined
    }
    
  };
  static validateEmail = (email) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(email);
  };
  static passCheck = (password) => {
    const upperCase = new RegExp("(?=.*[A-Z])");
    const lowerCase = new RegExp("(?=.*[a-z])");
    const number = new RegExp("(?=.*[0-9])");
    const eightChar = new RegExp("(?=.{8,})");
    if (
      eightChar.test(password) &&
      upperCase.test(password) &&
      lowerCase.test(password) &&
      number.test(password)
    )
      return true;
    else return false;
  };
  static addressCheck = (address) => {
    const data = new RegExp("([a-zA-Z0-9s,'-]*$)");
    return data.test(address);
  };

  static showToast(type, message, time = 2000) {
    const notificationObj = new showToastNotification();
    notificationObj.createNotification(type, message, time);
  }

  static isSignedIn = (data) => {
    return new Promise((resolve, reject) => {
      if (!Utils.isObjEmpty(data)) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  static getTimeStamp = () => {
    return new Date().getTime() + "_image.png";
  };

  static isEmpty(item_to_check) {
    if (
      item_to_check === null ||
      item_to_check === undefined ||
      item_to_check === "" ||
      item_to_check === "null"
    )
      return true;
    else return false;
  }

  static isEmptyString(item_to_check) {
    if (item_to_check === "") return true;
    else return false;
  }
  static isObjEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  static randomIntFromInterval(min, max) { 
  return Math.floor(Math.random() * (max - min + 1) + min)
  }

  static async checkAssetType (text,obj){
    let assetAvailabity = true
    if(!text.includes("+") && !text.includes("Add")  && !text.includes("Lose")){
      return  {obj:obj,assetAvailabity:true}
    }
    const textArray = text.split("+")
    for(var i = 0; i<textArray.length; i++){
      var operationType  = 0
      if(textArray[i].includes("None")){
        return obj
      }
      if(textArray[i].includes("Add")){
        operationType = 1
      }else if(textArray[i].includes("Lose")){
        operationType = 2
      }
      if(operationType === 0){
        return
      }
      if(textArray[i].includes("Time/Energy")){

        obj["Time/Energy"] = operationType === 1 ? obj["Time/Energy"] + 1 : obj["Time/Energy"] - 1
        if(obj["Time/Energy"] < 0){
          assetAvailabity = false
          }
        obj["Time/Energy"] =  obj["Time/Energy"] > 3 ? 3 : obj["Time/Energy"]
        obj["Time/Energy"] =  obj["Time/Energy"] < 0 ? 0 : obj["Time/Energy"]
        
      }
      else if(textArray[i].includes("Home/Family")){
        obj["Home/Family"] = operationType === 1 ? obj["Home/Family"]+1 : obj["Home/Family"] - 1
        if(obj["Home/Family"] < 0){
          assetAvailabity = false
          }
        obj["Home/Family"] =  obj["Home/Family"] > 3 ? 3 : obj["Home/Family"]
        obj["Home/Family"] =  obj["Home/Family"]  < 0 ? 0 : obj["Home/Family"]
        
      }
      else if( textArray[i].includes("Money/Debt")){
        obj["Money/Debt"] = operationType === 1 ? obj["Money/Debt"] + 1 : obj["Money/Debt"] - 1
        if(obj["Money/Debt"] < 0){
          assetAvailabity = false
          }
        obj["Money/Debt"] =  obj["Money/Debt"] > 3 ? 3 : obj["Money/Debt"]
        obj["Money/Debt"] =  obj["Money/Debt"]  < 0 ? 0 : obj["Money/Debt"]
        
      }
      else if(textArray[i].includes("Work/Job")){
        obj["Work/Job"] = operationType === 1 ? obj["Work/Job"] + 1 : obj["Work/Job"] - 1
        if(obj["Work/Job"] < 0){
          assetAvailabity = false
          }
        obj["Work/Job"] = obj["Work/Job"] > 3 ? 3 :obj["Work/Job"]
        obj["Work/Job"] = obj["Work/Job"]  < 0 ? 0 :obj["Work/Job"]
        
      }
      
    }
      console.log("Returned_assets",JSON.stringify(obj))
      let object ={obj:obj,assetAvailabity:assetAvailabity}
    return object
  }


  static async checkAssetEligibility (text,obj){
    let eligibility = true
    let addCase = false
    if(typeof text === "undefined" || text === ""){
      return false
    }
    const textArray = text.split("+")
    for(var i = 0; i<textArray.length; i++){
      if(!eligibility)
      {
        return !eligibility
      }
      var operationType  = 0
      if(textArray[i].includes("Add")){
        operationType = 1
      }else if(textArray[i].includes("Lose")){
        operationType = 2
      }
     
      if(textArray[i].includes("Time/Energy") && operationType === 2){
        eligibility = obj["Time/Energy"]  > 0 ?true :false
      }
      else if(textArray[i].includes("Home/Family")&& operationType === 2){
        eligibility = obj["Home/Family"]  > 0 ?true :false
      }
      else if( textArray[i].includes("Money/Debt")&& operationType === 2){
        eligibility = obj["Money/Debt"]  > 0 ?true :false
      }
      else if(textArray[i].includes("Work/Job")&& operationType === 2){
        eligibility = obj["Work/Job"]  > 0 ?true :false
      }
    }
    if(addCase && !text.includes("Lose")){
      return false
    }
    return !eligibility
  }

  static isAdminAuthenticated() {
    const token = localStorage.getItem('adminToken');
    return !!token;
  }

  static getAdminInfo() {
    const adminInfo = localStorage.getItem('adminInfo');
    return adminInfo ? JSON.parse(adminInfo) : null;
  }

  static clearAdminData() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminInfo');
  }
}

export default Utils;
